// extracted by mini-css-extract-plugin
export var actions = "_qd-4";
export var item = "_qd-1";
export var price = "_qd-3";
export var quantity = "_qd-2";
export var table = "_qd-0";